import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import {
  scribeTrackEvent,
  getCommonFacet,
  SCRIBE_SHOPIFY_STATES,
  SCRIBE_SHOPIFY_EVENTS,
  SCRIBE_SHOPIFY_PARAMS,
} from 'applications/scribe/instrumentations/track';
import { ROUTES_V2_PATHS } from 'constants/route-constants';
import { userInfoSelector } from 'selectors/app-selector';
import PageHeader from 'components/v2/page-header';
import PageHeaderNav from 'components/v2/page-header-nav';
import ShopifyTrackEventContext from '../track-event';
import ShopContextProvider from '../contexts/shop-context';
import ShopBasicSettingsSection from '../shopify-settings/shop-basic-settings-section';
import styles from './shopify-link.less';

const ShopifyLink = ({ userInfo }) => {
  const fireShopifyTrackEvent = ({ stateName, eventName, facets = {} }) => {
    const shopifyCommonFacets = {
      ...getCommonFacet(userInfo),
    };

    scribeTrackEvent({
      stateName,
      eventName,
      facets: {
        ...shopifyCommonFacets,
        ...facets,
      },
    });
  };

  const fireDefaultSettingsPageTrackEvent = () => {
    fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_SETTINGS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.DEFAULT,
      facets: {
        [SCRIBE_SHOPIFY_PARAMS.IS_SHOPIFY_STORE_LINKED]: false,
      },
    });
  };

  React.useEffect(() => {
    fireDefaultSettingsPageTrackEvent();
  }, []);

  return (
    <ShopifyTrackEventContext.Provider
      value={{
        fireShopifyTrackEvent,
      }}
    >
      <ShopContextProvider shop={null} userInfo={userInfo}>
        <div className={styles.ShopifyLink}>
          <PageHeader>
            <PageHeaderNav
              to={{ pathname: ROUTES_V2_PATHS.shopifyHome }}
              label={I18n.t('v2.commonButton.back')}
            />
            <h2>Settings</h2>
          </PageHeader>
          <ShopBasicSettingsSection isCreateMode />
        </div>
      </ShopContextProvider>
    </ShopifyTrackEventContext.Provider>
  );
};

ShopifyLink.propTypes = {
  userInfo: PropTypes.shape({}).isRequired,
};

const mapStateToProps = state => ({
  userInfo: userInfoSelector(state),
});

export default withRouter(connect(mapStateToProps)(ShopifyLink));
